<template>
<div>
	<div :class="{'collapsemenu':collapsemenu===true}" id="body-row">
		<Sidebar></Sidebar>
		<div id="panel-principal">
			 <navbar></navbar>
			<slot />
		</div>
	</div>
</div>
</template>
<script>

import navbar from '@/components/layout/Navbar'
import Sidebar from '@/components/layout/Sidebar'
import { mapState } from 'vuex'
export default {

	name: 'Content',
	components: {
		navbar,
		Sidebar
	},
	mounted () {
	},
	computed: {
		...mapState(['collapsemenu'])
	}
}

</script>
<style>
#content-body {
  background-image: none;
  background-color: #ffffff;
  color:black;
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue